import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { IonicModule, IonicSlides } from '@ionic/angular';
import { register } from 'swiper/element/bundle';

register();

@Component({
    selector: 'app-onboarding',
    templateUrl: './onboarding.component.html',
    styleUrls: ['./onboarding.component.scss'],
    imports: [IonicModule, CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingComponent {
  swiperModules = [IonicSlides];
  @ViewChild("slideContainer") slides: ElementRef | undefined;
  @Output() completeOnboarding = new EventEmitter<void>();

  constructor() { }

  next() {
    this.slides?.nativeElement.swiper.slideNext();
  }

  skip() {
    this.slides?.nativeElement.swiper.slideTo(2);
  }

  completeOnboardingClick() {
    this.completeOnboarding.emit();
  }

}
